<template>
    <div v-if="dataLoaded">
        <h3 class="mb-4">
            Entregas
            <b-button
                v-if="isUserStudenTeacherOrBetter"
                class="ml-2"
                variant="primary"
                @click="onCreateUpdate(null)"
            >
                <b-icon-plus /> Agregar
            </b-button>
        </h3>

        <template v-if="getActiveSiteAssignments">
            <b-card
                v-for="assignment in getActiveSiteAssignments"
                :key="`assgnmt-${assignment.id}`"
                class="my-2"
            >
                <b-card-text
                    class="clickable"
                    @click="onDisplayDetails(assignment)"
                >
                    <h5>{{ assignment.name }}</h5>
                </b-card-text>

                <template v-slot:footer>
                    <div class="float-right">
                        Fecha Límite:
                        <strong :class="assignment.class">
                            {{ assignment.displayDeadlineDate }}
                        </strong>
                    </div>

                    <b-button
                        v-if="isUserStudenTeacherOrBetter"
                        variant="warning"
                        size="sm"
                        class="ml-2"
                        @click="onCreateUpdate(assignment)"
                    >
                        <b-icon-pencil />
                    </b-button>

                    <b-button
                        v-if="isUserStudenTeacherOrBetter"
                        variant="danger"
                        size="sm"
                        class="ml-2"
                        @click="onDelete(assignment)"
                    >
                        <b-icon-trash-fill />
                    </b-button>
                </template>
            </b-card>
        </template>
        <p v-else>No existe ninguna entrega para este sitio web.</p>

        <!-- Create/Update Assignment Modal -->
        <AssignmentCreateUpdateModal
            v-if="isUserStudenTeacherOrBetter"
            @reloadAssignmentData="loadSiteAssignments()"
        />

        <!-- Review Assignment Files Modal -->
        <AssignmentReviewModal v-if="isUserStudenTeacherOrBetter" />

        <!-- Student Upload Assignment Modal -->
        <StudentAssignmentUploadModal />

    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AssignmentReviewModal from './AssignmentReviewModal'
import AssignmentCreateUpdateModal from './AssignmentCreateUpdateModal'
import StudentAssignmentUploadModal from './StudentAssignmentUploadModal'

export default {
    name: 'SiteAssignments',
    components: {
        AssignmentReviewModal,
        AssignmentCreateUpdateModal,
        StudentAssignmentUploadModal
    },
    data () {
        return {
            dataLoaded: false
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject'
        ]),
        ...mapGetters([
            'isUserStudenTeacherOrBetter',
            'getActiveSiteAssignments'
        ])
    },
    methods: {
        ...mapActions([
            'readServerTime',
            'readCourseSiteAssignments',
            'deleteSiteAssignment'
        ]),
        async loadSiteAssignments () {
            let loader = null
            this.dataLoaded = false
            try {
                loader = this.$loading.show()
                await this.readCourseSiteAssignments(this.activeSite.id)
                await this.readServerTime()
                this.dataLoaded = true
            } catch (err) {
                console.log(err)
                this.dataLoaded = false
                this.unknownErrorToast()
            } finally {
                loader.hide()
            }
        },
        onCreateUpdate (assignmentObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', assignmentObject)
            this.$bvModal.show('modal-create-assignment')
        },
        onDisplayDetails (assignmentObject) {
            this.$store.commit('SET_SELECTED_ASSIGNMENT', assignmentObject)
            if (this.isUserStudenTeacherOrBetter) {
                this.$bvModal.show('modal-assignment-review')
            } else {
                this.$bvModal.show('modal-student-upload-assignment')
            }
        },
        async onDelete (assignmentObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', assignmentObject)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar la entrega.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDelete()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDelete () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, assignmentId: this.selectedCrudObject.id }
                await this.deleteSiteAssignment(payloadData)
                await this.loadSiteAssignments()
                this.$root.infoToast('La entrega ha sido eliminada exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar la entrega, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    },
    async created () {
        this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        await this.loadSiteAssignments()
    }
}
</script>
